module.exports = __webpack_public_path__ + "img/22.0559b6fb.jpg";